import { render, staticRenderFns } from "./listacatalogomobile.vue?vue&type=template&id=2ef65a24&scoped=true"
import script from "./listacatalogomobile.vue?vue&type=script&lang=js"
export * from "./listacatalogomobile.vue?vue&type=script&lang=js"
import style0 from "./listacatalogomobile.vue?vue&type=style&index=0&id=2ef65a24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef65a24",
  null
  
)

export default component.exports